import { post, get } from './';

export const requestConnection = (dmcOrganizationId, type) =>
  post(`/api/internal/to-connection-requests/${dmcOrganizationId}/${type}`);

export const getOrganizationByTo = ({
  countries,
  withConnectionRequestType,
}) => {
  const params = new URLSearchParams();

  if (countries?.length) {
    countries.forEach(country => params.append('countries[]', country));
  }

  if (withConnectionRequestType !== undefined) {
    params.append('withConnectionRequestType', withConnectionRequestType);
  }

  return get(`/api/internal/organizations/to?${params.toString()}`);
};

export const getOrganizationByToDmc = ({
  toOrganizationId,
  dmcOrganizationId,
  kind,
}) =>
  get(
    `/api/internal/to-connection-requests/${dmcOrganizationId}/${toOrganizationId}?kind=${kind}`,
  );
